import * as z from "zod/v4";

export const disputeEvidenceSchema_ = z.object({
  id: z.coerce.bigint(),
  disputeId: z.coerce.bigint(),
  accessActivityLog: z.string().nullish(),
  customerCommunicationFileUrl: z.string().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export const disputeEvidenceSchema: z.ZodType<DisputeEvidence> =
  disputeEvidenceSchema_;
export interface DisputeEvidence
  extends z.infer<typeof disputeEvidenceSchema_> {}

export interface UpsertDisputeEvidenceInput {
  disputeId: bigint;
  accessActivityLog?: string | null;
  customerCommunicationFileUrl?: string | null;
}
